import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoleHelpDialogComponent } from './role-help-dialog.component';
import { MaterialModule } from 'src/app/material.module';
import { TranslateModule } from '@ngx-translate/core';

import { TutorialPanelModule } from '../../tutorial-panel/tutorial-panel.module';

@NgModule({
    declarations: [RoleHelpDialogComponent],
    imports: [
        CommonModule,
        MaterialModule,
        TranslateModule,
        TutorialPanelModule
    ],
    exports: [RoleHelpDialogComponent]
})
export class RoleHelpDialogModule { }
